module.exports = __webpack_public_path__ + "static/media/bkg-actualites.d6fad45b.jpg";